module.exports = __webpack_public_path__ + "img/other_pay_linepay2.31be4467.svg";